import { Injectable } from '@angular/core';
import type { IProductDataV3 } from '@df/catalog/product/product';
import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { ProductConfigurationConfigurable } from '@df/module-product-configuration/model/configurable/product-configuration-configurable';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { ProductDecorator } from '../../../catalog/model/product/product.decorator';

@Injectable()
export class ProductConfigurationPlugin implements NProductConfiguration.IPlugin {
    /**
     * Services
     */
    private productConfiguration!: ProductConfigurationConfigurable;

    /**
     * Init
     */
    init(productConfiguration: ProductConfiguration) {
        this.productConfiguration = productConfiguration as ProductConfigurationConfigurable;
    }

    getSelectionProduct(attributeCode: string): ProductDecorator<IProductDataV3> | undefined {
        const value = this.productConfiguration.selection$.value[attributeCode];
        const option = this.productConfiguration.options$.value
            ?.find(option => option.attribute.id === attributeCode)
            ?.values.find(option => option.value === value);

        if (option) {
            return option.product as ProductDecorator<IProductDataV3>;
        }

        return undefined;
    }

    needSelectAttribute(): string | undefined {
        const selection = this.productConfiguration.selection$?.value || {};
        const product = this.productConfiguration.product$?.value;

        if (Object.keys(selection).length) {
            return product.configurableAttributeCodes?.find(i => !selection[i]);
        }

        return undefined;
    }
}

ProductConfiguration.plugins.push(ProductConfigurationPlugin);
